/**
 * 只请求数据不做任何处理 处理和交互都放在外面 让数据 尽可能的干净简洁
 */
/* eslint-disable */
let bfmapData = {
    geonearcarposData: '', // 最近空车位数据
    seturl: 'https://www.beefindtech.com:8443', // 地图请求地址
    buildSeturl: 'https://www.51beefind.com', // 项目请求地址
    /**
     * 请求项目信息
     *
     */
    getBuildData: function (f) {
        $.ajax({
            type: 'post',
            url: bfmapData.seturl + '/mspringmvc/bllist',
            dataType: 'json',
            success: res => {
                if (f) {
                    f(res);
                }
            }
        })
    },
    /**
     * 请求楼层数据
     */
    getFloorData: function (build, f) {
        $.ajax({
            url: bfmapData.seturl + '/mapserve/floor',
            type: 'post',
            data: {
                'buildingID': build
            },
            dataType: 'JSON',
            success: data => {
                if (f) {
                    f(data);
                }
            }
        })
    },
    /**
     * 请求车位数据
     */
    getPakingData: function (floorId, build, f) {
        $.ajax({
            url: bfmapData.seturl + '/gos/gosweb/parkPosition',
            type: 'post',
            data: {
                floor_id: floorId,
                build_id: build
            },
            success: res => {
                if (f) {
                    f(res);
                }
            }
        })
    },
    /**
     * 获取项目的分区色块颜色
     */
    getArea: function (build_id, floor_id, f) {
        $.ajax({
            url: bfmapData.seturl + '/gos/gosweb/area',
            type: "get",
            data: {
                build_id: build_id,
                floor_id: floor_id,
            },
            success: function (res) {
                if (f) {
                    f(res);
                }
            }
        });
    },
    // 创建GeoJson
    createGeoJSON: function (res, type) {
        var customGeojson = {
            'type': 'FeatureCollection',
            'features': []
        };
        for (var i in res) {
            var customGeojsonFeature = {
                type: 'Feature',
                geometry: {
                    type: type,
                    coordinates: res[i].point
                },
                properties: res[i]
            };
            customGeojson.features.push(customGeojsonFeature);
        }
        return customGeojson;
    },
    /**
     * 拼接symbol层地图geojson
     */
    setGeojson: function (res) {
        var customGeojson = {
            'type': 'FeatureCollection',
            'features': []
        };
        for (var i in res) {
            var customGeojsonFeature = {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: res[i].point
                },
                properties: res[i]
            };
            customGeojson.features.push(customGeojsonFeature);
        }
        return customGeojson;
    },
    /**
     * 拼接symbol层地图geojson
     */
    setGeojson2: function (res, jsonType) {
        var customGeojson = {
            'type': 'FeatureCollection',
            'features': []
        };
        for (var i in res) {
            var customGeojsonFeature = {
                type: 'Feature',
                geometry: {
                    type: jsonType,
                    coordinates: res[i].point
                },
                properties: res[i]
            };
            customGeojson.features.push(customGeojsonFeature);
        }
        return customGeojson;
    },
    // 创建线条的GeoJson
    crawLineGeoJSON(coor, data) {
        let line = {
            'type': 'FeatureCollection',
            'features': []
        };
        for (let key in data) {
            if (!coor[key]) continue;
            if (Array.isArray(data[key])) {
                for (let i = 0; i < data[key].length; i++) {
                    let obj = {
                        type: 'Feature',
                        geometry: {
                            type: 'LineString',
                            coordinates: [
                                coor[key],
                                data[key][i]
                            ]
                        },
                        properties: {
                            coordinates: coor[key]
                        }
                    };
                    line.features.push(obj);
                }
            }
        }
        return line;
    },
}
export default bfmapData;
